import styled, { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"

export const Container = styled.div`
  margin-bottom: 0rem;
  ${({ gridArea }) =>
    gridArea !== undefined &&
    css`
      ${breakpoint("tablet")`
      grid-area: ${gridArea};
    `}
    `}
  ${breakpoint("tablet")`
    margin-bottom: 2rem;
  `}
`

export const MenuButton = styled.div`
  text-align: right;

  ${breakpoint("tablet")`
    display: none;
  `}
`

export const Logo = styled.div`
  ${breakpoint("tablet")`
    display: none;
  `}
`

export const StyledHeading = styled.h1`
  margin: 0;
  letter-spacing: -1px;
  color: ${({ theme }) => theme.colors.fields.text};
  margin-bottom: 32px;

  ${breakpoint("desktop")`
    font-size: 32px;    
  `}
`
